'use strict';

require('../../style/index.less');


//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.6.1@antd/lib/icon/style/index.js
// module id = 416
// module chunks = 1